export default __webpack_public_path__ + "static/media/blog.27df329a.png";